/** @format */
import { ReactNode } from 'react';

export enum CardBackgroundColor {
    WHITE = 'white',
    MIDNIGHT = 'midnight',
    SKY = 'sky',
    SUSTAINABILITY = 'sustainability',
    PINK = 'pink',
}

export type StyledCardBackgroundProps = {
    color?: CardBackgroundColor;
    expandOnHover?: boolean;
    tag?: string;
};

export type CardBackgroundProps = StyledCardBackgroundProps & {
    children?: ReactNode;
    className?: string;
    'data-testid'?: string;
};
